<template>
    <div v-if="summary" class="hidden md:block summary_box_specific h-0" :class="[summary ? summary.slug : '']">
        <img class="relative bottom-0 right-0 block w-full h-full object-contain md:object-cover" />
        <div class="summary_logo relative bottom-0 right-0">
            <img src="fr/images/summary/summary-logo.png" alt="" />
        </div>
        <div class="summary_text">
            <template v-for="content in $t('summary').getSummaryContent()">
                <p class="add_custom_font_size_1 text-md md:text-sm xl:text-2xl font-bold tracking-wide uppercase text-right" :key="content.text_001" v-html="content.text_001"></p>
                <p class="add_custom_font_size_2 pl-2 whitespace-nowrap tracking-wide uppercase text-right" :key="content.text_002" v-html="content.text_002"></p>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SummaryBoxInitial',
        props: {
            summary: null
        }
    };
</script>

<style scoped lang="scss">
    .summary_box_specific {
            width: calc($box_size_mobile - $box_spacing);
            padding-bottom: calc($box_size_mobile - $box_spacing);
            margin-top: $box_spacing;
            @media (min-width: 768px) {
                // width: calc(100% - ($box_size - ($box_spacing)) * 3 - ($box_spacing * 18));
                width: 16%;
                padding-bottom: calc($box_size - $box_spacing);
                margin-left: $box_spacing;
                position: relative;
                // bottom: -20px;
                right: 0;
            }
            @media (min-width: 1025px) {
                width: 16.6%;
            }
            @media (min-width: 1400px) {
                width: 16.8%;
            }
            @media (min-width: 1600px) {
                width: 16.9%;
            }
            @media (min-width: 1800px) {
                width: 17.2%;
            }
    }
    .summary_logo {
        display: none;
        margin-top: 0;
        @media (min-width: 768px) {
            display: flex;
            justify-content: right;
            margin-bottom: 0.25rem;
            
        }
        @media (min-width: 1025px) {
            display: flex;
            justify-content: right;
            margin-bottom: 1rem;
        }
    }
    img{
        @media (min-width: 768px) {
            width: 70px;
        }
        @media (min-width: 1280px) {
            font-size: 1000px;
        }
        @media (min-width: 1536px) {
            width: 120px;
            padding-bottom: 0.5rem;
        }
    }
    .add_custom_font_size_1{
        @media (min-width: 768px) {
            font-size: 9px;
            line-height: 1.5;
        }
        @media (min-width: 1000px) {
            font-size: 15px;
        }
        @media (min-width: 1280px) {
            font-size: 20px;
        }
        @media (min-width: 1536px) {
            font-size: 22px;
        }
        @media (min-width: 1800px) {
            font-size: 26px;
        }
    }
     
    .add_custom_font_size_2{
        @media (min-width: 768px) {
            font-size: 7px;
        }
        @media (min-width: 1280px) {
            font-size: 12px;
        }
        @media (min-width: 1536px) {
            font-size: 14px;
        }
        @media (min-width: 1800px) {
            font-size: 16px;
        }
    }
</style>
